import React from "react";
import {
  Link,
  useLocation,
} from "react-router-dom";

import {
  motion,
} from "framer-motion";

import {
  CheckCircle,
  WhatsappLogo,
} from "@phosphor-icons/react";

const inr = (n) =>
  `₹${Number(n || 0).toLocaleString(
    "en-IN"
  )}`;

export default function OrderSuccess() {
  const {
    state,
  } = useLocation();

  const number =
    state?.orderNumber;

  const discountAmount =
    Number(
      state?.discountAmount ||
        0
    );

  return (
    <div className="pt-28 min-h-screen flex items-center justify-center">

      <motion.div
        initial={{
          opacity: 0,
          y: 20,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        className="text-center max-w-xl px-6 pb-20"
      >

        <CheckCircle
          size={78}
          weight="light"
          className="text-accent mx-auto mb-6"
        />

        <p className="text-xs uppercase tracking-[.25em] text-muted-foreground mb-4">
          Order confirmed
        </p>

        <h1 className="text-4xl md:text-5xl tracking-tight mb-4">
          Thank you for your order.
        </h1>

        {number && (
          <div className="border border-border p-5 my-7">

            <p className="text-xs uppercase tracking-widest text-muted-foreground">
              Order number
            </p>

            <p className="text-2xl mt-2 font-mono">
              {number}
            </p>

            {state?.total != null && (
              <>
                {discountAmount >
                  0 && (
                  <p className="text-sm mt-3 text-green-700">
                    Student discount:
                    {" "}
                    -{inr(
                      discountAmount
                    )}
                  </p>
                )}

                <p className="text-sm mt-2">
                  {inr(
                    state.total
                  )}

                  {" · "}

                  {state.paymentStatus ===
                  "paid"
                    ? "Paid online"
                    : "Payment pending"}
                </p>
              </>
            )}

          </div>
        )}

        <p className="text-muted-foreground leading-7 mb-8">
          Our team will confirm sizes
          and delivery details with you
          shortly on WhatsApp.
        </p>

        <div className="flex justify-center gap-3">

          <a
            href="https://wa.me/919356070802"
            target="_blank"
            rel="noreferrer"
            className="rounded-full bg-accent text-accent-foreground px-6 py-3 text-xs uppercase tracking-widest flex items-center gap-2"
          >
            <WhatsappLogo
              size={17}
            />

            WhatsApp
          </a>

          <Link
            to="/shop"
            className="rounded-full border border-border px-6 py-3 text-xs uppercase tracking-widest"
          >
            Continue shopping
          </Link>

        </div>

      </motion.div>
    </div>
  );
}
